import { productTypesInversed, ProductTypesKeys } from '@teinor/erp/types/company/product'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { useState } from 'react'
import { TableTypeStock } from './types'

interface TableTypeStockDictProps {
    isVariantProduct: boolean
    productType: ProductTypesKeys
}
const useTableTypeStockSelector = ({ isVariantProduct, productType }: TableTypeStockDictProps) => {
    const [tableType, setTableType] = useState<TableTypeStock>('individual')

    const { t } = useTwinTranslation()
    const dictTableTypeStock: TwinDictionary = {
        'individual': { name: t('individual', 'Individual') },
    }
    if (isVariantProduct) {
        dictTableTypeStock['groupByVariants'] = { name: t('groupedByVariants', 'Agrupado por variantes') }
    } else if (productType === productTypesInversed['lots']) {
        dictTableTypeStock['groupByUniqueNumber'] = { name: t('groupedByLots', 'Agrupado por lotes') }
    } else if (productType === productTypesInversed['serialized']) {
        dictTableTypeStock['groupByUniqueNumber'] = { name: t('groupedBySerialNumber', 'Agrupado por número de serie') }
    }
    return { dictTableTypeStock, tableType, setTableType }
}

export default useTableTypeStockSelector